import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import React from 'react';
import { components } from 'react-select';

export const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <ArrowDropDown />
      </components.DropdownIndicator>
    )
  );
};
